import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { ChatInboxModel } from '@/models'

export interface GetCustomInboxesRequest {
  buildingId: number
}

export interface GetCustomInboxesResponse {
  inbox: ChatInboxModel
  inboxes: ChatInboxModel[]
}

export const getCustomInboxesQueryKey = (data: GetCustomInboxesRequest) => [
  'useGetCustomInboxes',
  data,
]

export const getCustomInboxes = async (params: GetCustomInboxesRequest) => {
  const response = await authAPI.get<GetCustomInboxesResponse>('/chat-inbox/custom', {
    params: { ...params, all: true },
  })
  return response.data
}

export interface UseGetCustomInboxesProps {
  enabled?: boolean
}

export const useGetCustomInboxes = (
  data: GetCustomInboxesRequest,
  { enabled }: UseGetCustomInboxesProps = {},
) => {
  return useQuery({
    enabled,
    queryFn: () => getCustomInboxes(data),
    queryKey: getCustomInboxesQueryKey(data),
  })
}
